import _ from 'lodash';
import { useRef } from 'react';

/**
 * Keep a stable reference to a value, only updating
 * when the deep contents actually change.
 */
export default function useStable(value) {
  const ref = useRef(value);
  if (!_.isEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
}
